function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 14.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9z",
  stroke: "#61676C"
});

var SvgIconCircleGray = function SvgIconCircleGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDE0LjVDNy41MTQ2NCAxNC41IDUuNSAxMi40ODU0IDUuNSAxMEM1LjUgNy41MTQ2NCA3LjUxNDY0IDUuNSAxMCA1LjVDMTIuNDg1NCA1LjUgMTQuNSA3LjUxNDY0IDE0LjUgMTBDMTQuNSAxMi40ODU0IDEyLjQ4NTQgMTQuNSAxMCAxNC41WiIgc3Ryb2tlPSIjNjE2NzZDIi8+Cjwvc3ZnPgo=";
export { SvgIconCircleGray as ReactComponent };